import {
  autologin,
  getLegacyAccessToken,
  login,
  loginViaOTP,
  requestPasswordEmail,
  adminLogin,
} from "@/api/auth";
import axios from "@/api/axios-auth";

const auth = {
  namespaced: true,
  state: () => ({
    status: {
      jwtToken: {
        initialized: false,
        refreshing: false,
        error: false,
        errorCode: 0,
      },
    },
    jwtToken: localStorage.getItem("jwtToken") || "",
  }),
  getters: {
    isAuthenticated: (state) => !!state.jwtToken,
  },
  actions: {
    logIn({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("SET_REFRESHING_TRUE", "jwtToken");
        commit("SET_ERROR_FALSE", "jwtToken");
        login(user)
          .then((resp) => {
            const jwtToken = resp.data.jwtToken;
            commit("SET_INITIALIZED_TRUE", "jwtToken");
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_JWT_TOKEN", jwtToken);
            resolve(resp);
          })
          .catch((err) => {
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_ERROR_TRUE", "jwtToken");
            commit("REMOVE_JWT_TOKEN");
            reject(err);
          });
      });
    },
    logInViaOTP({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("SET_REFRESHING_TRUE", "jwtToken");
        commit("SET_ERROR_FALSE", "jwtToken");
        loginViaOTP(user)
          .then((resp) => {
            const jwtToken = resp.data.jwtToken;
            commit("SET_INITIALIZED_TRUE", "jwtToken");
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_JWT_TOKEN", jwtToken);
            resolve(resp);
          })
          .catch((err) => {
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_ERROR_TRUE", "jwtToken");
            commit("REMOVE_JWT_TOKEN");
            reject(err);
          });
      });
    },
    autoLogIn({ commit }, { token: token, is_divvy_admin_flow: is_divvy_admin_flow }) {
      return new Promise((resolve, reject) => {
        commit("SET_REFRESHING_TRUE", "jwtToken");
        commit("SET_ERROR_FALSE", "jwtToken");
        autologin({token, is_divvy_admin_flow})
          .then((resp) => {
            const jwtToken = resp.data.jwtToken;
            commit("SET_INITIALIZED_TRUE", "jwtToken");
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_JWT_TOKEN", jwtToken);
            resolve(resp);
          })
          .catch((err) => {
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_ERROR_TRUE", "jwtToken");
            commit("REMOVE_JWT_TOKEN");
            reject(err);
          });
      });
    },
    adminLogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("SET_REFRESHING_TRUE", "jwtToken");
        commit("SET_ERROR_FALSE", "jwtToken");
        adminLogin(user)
          .then((jwtToken) => {
            commit("SET_INITIALIZED_TRUE", "jwtToken");
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_JWT_TOKEN", jwtToken);
            resolve();
          })
          .catch((err) => {
            commit("SET_REFRESHING_FALSE", "jwtToken");
            commit("SET_ERROR_TRUE", "jwtToken");
            commit("REMOVE_JWT_TOKEN");
            reject(err);
          });
      });
    },
    requestPasswordEmail({ commit }, email) {
      return new Promise((resolve, reject) => {
        requestPasswordEmail(email)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetchLegacyAccessToken({ commit }) {
      return new Promise((resolve, reject) => {
        getLegacyAccessToken()
          .then((accessToken) => {
            resolve(accessToken);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    logOut({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_INITIALIZED_FALSE", "jwtToken");
        commit("REMOVE_JWT_TOKEN");
        commit("REMOVE_SIDEBAR_SUB_MODULES");
        resolve();
      });
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true;
    },
    SET_INITIALIZED_FALSE: (state, dataName) => {
      state.status[dataName].initialized = false;
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true;
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false;
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true;
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false;
    },
    SET_JWT_TOKEN: (state, payload) => {
      localStorage.setItem("jwtToken", payload);
      axios.defaults.headers.common.Authorization = "Bearer " + payload;
      state.jwtToken = payload;
    },
    REMOVE_JWT_TOKEN: (state) => {
      localStorage.removeItem("jwtToken");
      state.jwtToken = "";
    },
    REMOVE_SIDEBAR_SUB_MODULES: () => {
      localStorage.removeItem("sidebarSubModules");
    },
  },
};

export default auth;
